// import { Paper, TextField, Grid, MenuItem, Button, stepButtonClasses, Typography } from "@mui/material";
// import { Box } from "@mui/system";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useLocation, useParams } from "react-router-dom"
// import { getUserById, updateUserById } from "../../api/user";
// import useSnackbar from "../../hooks/useSnackbar.js";

// export default function QuestionDetail() {

//     const { data: user } = useSelector(state => state.user);
//     const location = useLocation();
//     const params = useParams();

//     const snackbar = useSnackbar();

//     const [userData, setUserData] = useState({
//         firstname: "", lastname: "", email: "", phone: "", role: "",
//         city: "", state: "", zipcode: "", address: "", address2: "", country: ""
//     });

//     const [editDisabled, setEditDisabled] = useState(true);

//     useEffect(() => {
//         if (location.state?.id) {
//             setUserData(extractUserData(location.state));
//         } else {
//             fetchUserData();
//         }
//     }, [location.state]);

//     function fetchUserData() {
//         setTimeout(() => {
//             if (userData.firstname) return;
//             getUserById(user.token, params.id).then(({ data }) => {
//                 setUserData(extractUserData(data.data));
//             }).catch(() => {

//             })
//         }, [400])
//     }

//     function onDetailsChange({ target }) {
//         setUserData(prev => ({ ...prev, [target.name]: target.value }));
//     }

//     async function onProfileUpdate() {
//         try {
//             await updateUserById(user.token, params.id, getUpdatableProfileData(userData));
//             snackbar.showSuccess("User Updated");
//             setEditDisabled(true);
//         } catch (error) {
//             console.log(error);
//             snackbar.showError();
//         }
//     }

//     return <>
//         <Box display='flex' justifyContent='space-between' columnGap={2} pb={2}>
//             <Box>
//                 <Typography>User Details</Typography>
//             </Box>
//             <Box display='flex' columnGap={2}>
//                 {
//                     editDisabled ? <></> : <Button size="small" variant="contained" color="warning"
//                         onClick={onProfileUpdate}
//                     >Save
//                     </Button>
//                 }
//                 <Button size="small" variant="contained" onClick={() => setEditDisabled(prev => !prev)}>
//                     {editDisabled ? "Edit" : "Cancel"}
//                 </Button>
//             </Box>
//         </Box>
//         <Paper sx={{ p: 2 }}>
//             <Grid container spacing={2}>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="First Name" name="firstname" value={userData.firstname}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="Last Name" name="lastname" value={userData.lastname}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} type="tel" disabled={editDisabled}
//                         label="Phone" name="phone" value={userData.phone}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} type="email" disabled={true}
//                         label="Email" name="email" value={userData.email}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="Role" name="role" value={userData.role} select
//                     >
//                         <MenuItem value="ADMIN">Admin</MenuItem>
//                         <MenuItem value="USER">User</MenuItem>
//                     </TextField>
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="Address" name="address" value={userData.address}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="Address Line 2" name="address2" value={userData.address2}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="City" name="city" value={userData.city}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="State" name="state" value={userData.state}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="Zipcode" name="zipcode" value={userData.zipcode}
//                     />
//                 </Grid>
//                 <Grid item xs={12} md={6} lg={4}>
//                     <TextField size="small" fullWidth onChange={onDetailsChange} disabled={editDisabled}
//                         label="Country" name="country" value={userData.country}
//                     />
//                 </Grid>
//             </Grid>
//         </Paper>
//     </>
// }

// function extractUserData(data) {
//     return {
//         firstname: data.firstname || "",
//         lastname: data.lastname || "",
//         email: data.email || "",
//         phone: data.phone || "",
//         role: data.role || "",
//         city: data.city || "",
//         state: data.state || "",
//         zipcode: data.zipcode || "",
//         address: data.address || "",
//         address2: data.address2 || "",
//         country: data.country || ""
//     }
// }

// function getUpdatableProfileData(data) {
//     return {
//         firstname: data.firstname,
//         lastname: data.lastname,
//         phone: data.phone,
//         role: data.role,
//         city: data.city,
//         state: data.state,
//         zipcode: data.zipcode,
//         address: data.address,
//         address2: data.address2,
//         country: data.country
//     }
// }

//////////////////////////////
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Grid,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  FormControl,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  Autocomplete,
  Chip,
  FormLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import useSnackbar from "../../hooks/useSnackbar.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";
import CaseTypeSelector from "../../components/CaseTypeSelector.jsx";
import useCaseTypesList from "../../hooks/useCaseTypesList.js";
import { updateCaseQuestion } from "../../api/caseQuestions.js";

const emptyQuestionData = {
  question: "",
  multiple: false,
  case_type: "",
  order: 1,
  options: ["Yes", "No"],
};

export default function QuestionDetail() {
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();
  const { state } = useLocation();

  const navigate = useNavigate();
  const params = useParams();

  const [caseType, setCaseType] = useState(null);
  const { caseTypeList } = useCaseTypesList();
  const [list, setList] = useState([]);
  useEffect(() => {
    setList(caseTypeList.map((t) => ({ title: t })));
  }, [caseTypeList]);

  const { data: user } = useSelector((state) => state.user);

  const [questionData, setQuestionData] = useState(emptyQuestionData);
  useEffect(() => {
    if (state) {
      setQuestionData(state);
      setCaseType(state.case_type);
    } else {
      navigate("/questions");
    }
  }, []);

  const onInputChange = ({ target }) => {
    if (target.name === "multiple") {
      if (target.value === "false") {
        setQuestionData((prev) => ({
          ...prev,
          [target.name]: target.value,
          options: ["Yes", "No"],
        }));
      } else {
        setQuestionData((prev) => ({
          ...prev,
          [target.name]: target.value,
          //   options: state.options,
        }));
      }
    } else {
      setQuestionData((prev) => ({ ...prev, [target.name]: target.value }));
    }
  };
  ///
  const onUpdateFormSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateCaseQuestion(user.token, params.id, {
        order: questionData.order,
        question: questionData.question,
        options: questionData.options,
        case_type: caseType.title,
        multiple: /true/.test(questionData.multiple),
      });
      snackbar.showSuccess("Updated");
      navigate("/questions");
    } catch (err) {
      handleError(err);
    }
  };

  return (
    <>
      {/* <Box mb={2} display="flex" justifyContent="flex-end">
        <Link to="/questions">
          <Button variant="contained" size="small" color="secondary">
            Cancel
          </Button>
        </Link>
      </Box> */}
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Typography className="heading-title">Update Question</Typography>
        </Box>
        <Box px={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <FormControl>
                <FormLabel>Multiple Choice</FormLabel>
                <RadioGroup
                  row
                  value={questionData.multiple}
                  onChange={({ target }) =>
                    onInputChange({
                      target: { name: "multiple", value: target.value },
                    })
                  }
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={8} lg={8}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Question"
                name="question"
                value={questionData.question}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <CaseTypeSelector
                list={list}
                value={caseType}
                setValue={setCaseType}
              />
            </Grid>
            <Grid item xs={12} md={8} lg={8}>
              <OptionsSelector
                onChange={onInputChange}
                value={questionData.options}
                options={["Yes", "No"]}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Order"
                name="order"
                value={questionData.order}
                type="number"
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box display="flex" columnGap={1} justifyContent="flex-end">
                <Link to="/questions">
                  <Button
                    variant="outlined"
                    size="large"
                    className="black-border-button"
                  >
                    Cancel
                  </Button>
                </Link>

                <Button
                  size="large"
                  variant="contained"
                  onClick={onUpdateFormSubmit}
                  className="blue-button"
                  disabled={/^trial_user$/i.test(user.roles) ? true : false}
                >
                  Update
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}

function OptionsSelector({ onChange, value, options = [] }) {
  return (
    <Autocomplete
      fullWidth
      size="small"
      multiple
      id="tags-filled"
      options={options}
      value={value}
      freeSolo
      onChange={(e, value) => onChange({ target: { name: "options", value } })}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            size="small"
            label={option}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          required
          size="small"
          variant="outlined"
          label="Options"
          placeholder="Options"
        />
      )}
    />
  );
}
